/**
 * Customer details schemas
 */

import { z } from 'zod';
import { AddressSchema } from '../backend_config.types';
import type { CustomerDetails } from '../payment.types';
import { PhoneNumberSchema } from './common.schemas';

export const CustomerDetailsSchema: z.ZodType<CustomerDetails> = z.object({
    customerName: z.string().optional(),
    mainPhone: PhoneNumberSchema.optional(),
    otherPhones: z.array(PhoneNumberSchema).default([]),
    mainEmail: z.string().email().optional(),
    address: AddressSchema.optional(),
    billingAddress: AddressSchema.optional(),
}).strict();
